export default __webpack_public_path__ + "static/menu-ordered-furniture-30eead0d33620996fdd7ede4115ed2da.jpeg";